"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insufficientBalanceByCurrency = void 0;
exports.insufficientBalanceByCurrency = {
    USD: 0.09,
    EUR: 0.09,
    GBP: 0.09,
    AUD: 0.09,
    CAD: 0.09,
    NZD: 0.09,
    RUB: 5,
    PLN: 0.09,
    KZT: 5,
    UZS: 1,
    AZN: 1,
    TJS: 1,
    SEK: 1,
};
